import React, { useRef, useState } from 'react';
import axios from 'axios';
import { API_URL, USER_SESSION_KEY } from '../../Constants';
import { useNavigate } from 'react-router-dom';
import './Login.scss'
import { handleAxiosResponse } from '../../Util';

export default function Login() {

    const userControl = useRef('');
    const passwordControl = useRef('');

    const [error, setError] = useState(null);

    const navigate = useNavigate();

    const onLogin = (event)=>{
        event.preventDefault();
        const user = userControl.current.value;
        const password = passwordControl.current.value;
        if(user && password){
            const data = {
                user,
                password
            }
            doLogin(data);
        }
    }

    const doLogin = async (loginData) => {
        try{
            const serverResponse = await axios.post(`${API_URL}/login`, loginData);
            const data = handleAxiosResponse(serverResponse);
            
            if(data.success){
                localStorage.setItem(USER_SESSION_KEY, data.user);
                navigate('/admin');
            }else{
                setError('Datos inválidos');
            }
        }catch(error){
            console.error(error);
            if(error.status === 404){
                setError('Datos inválidos');
            }
        }
    }


    return (
        <div className='login'>
            <form className='form' onSubmit={onLogin}>
                <div className='row'>
                    <div className='_50 align-right'>
                        <label className='label' htmlFor='user'>Usuario</label>
                    </div>
                    <div className='_50'>
                        <input className='login-username' id='user' type='text' ref={userControl}/>
                    </div>
                </div>
                <div className='row'>
                    <div className='_50 align-right'>
                        <label className='label' htmlFor="password">Contraseña</label>
                    </div>
                    <div className='_50'>
                        <input className='login-password' id='password' type='password' ref={passwordControl}/>
                    </div>
                </div>
                <div className='row'>
                    <div className='_50'>
                    </div>
                    <div className='_50'>
                        {
                            error? <div className='error'>{error}</div> : ''
                        }
                    </div>
                </div>
                <div className='row'>
                    <div className='_50'>
                    </div>
                    <div className='_50'>
                        <button className='save-button primary-button' type='submit'>Entrar</button>
                    </div>
                </div>
            </form>
        </div>
    )
}
